import React from 'react';
import { Popup as Modal } from 'reactjs-popup';
import { GroupingModal } from './GroupingModal';

interface IGroupingOverlayProps {
  showGroupOverlay: boolean;
  setShowGroupOverlay: (show: boolean) => void;
  selectedServiceRequestIds: string[];
  existingGroups: any[];
  fetchDashboard: () => void;
  groupingPropertyId: string | null;
}

export const GroupingOverlay = ({
  showGroupOverlay,
  setShowGroupOverlay,
  selectedServiceRequestIds,
  existingGroups,
  fetchDashboard,
}: IGroupingOverlayProps) => {
  return (
    <>
      <Modal
        open={showGroupOverlay}
        onClose={() => setShowGroupOverlay(false)}
        closeOnDocumentClick={true}
        className="popup-content"
      >
        <GroupingModal
          serviceRequestIds={selectedServiceRequestIds}
          existingGroups={existingGroups}
          onClose={() => setShowGroupOverlay(false)}
          fetchDashboard={fetchDashboard}
          propertyId={null}
        />
      </Modal>
    </>
  );
};
